import type { AutomationGroup } from '@/api'
import type { Referential } from '../types'
import { countDataRowsFromRanges } from './gridData'
import { splitPayloadRules } from './referentialAutomationRules'

export function mapAutomationGroupToReferential(
  item: AutomationGroup,
  groupId: string
): Referential {
  const matching = item.matching ?? []
  const payload = item.payload ?? []
  const { actions } = splitPayloadRules(payload, matching)
  const hasAutomation = matching.length > 0 || actions.length > 0
  const ranges = item.ranges ?? undefined

  return {
    id: item.id,
    name: item.name,
    description: item.description ?? undefined,
    groupId: item.refGroup ?? groupId,
    configurationId: item.refConfiguration,
    clientOrganizationId: item.refClientOrganization ?? undefined,
    active: item.active,
    autoRunOnCreate: item.autoRunOnCreate ?? false,
    createdAt: item.createdAt ?? undefined,
    updatedAt: item.updatedAt ?? item.createdAt ?? undefined,
    conditionCount: matching.length,
    actionCount: actions.length,
    automationCount: hasAutomation ? 1 : 0,
    matching,
    payload,
    ranges,
    rowCount: countDataRowsFromRanges(ranges),
  }
}
